import { CommonModule } from '@angular/common';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import * as i0 from "@angular/core";
export class AddButtonAutocompleteModule {
}
AddButtonAutocompleteModule.ɵfac = function AddButtonAutocompleteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AddButtonAutocompleteModule)(); };
AddButtonAutocompleteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AddButtonAutocompleteModule });
AddButtonAutocompleteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule, CommonModule] });
